import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar"; import { store } from "../../App"; import { IoIosReturnLeft } from "react-icons/io"; import MasterService from "../../Services/MasterService"; import { AiFillFileExcel, AiOutlineEye, AiOutlineSearch } from "react-icons/ai"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import { Container, Row, Col, Nav, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"; import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa"; import autoTable from "jspdf-autotable"; import KpiService from "../../Services/KpiService";
import { allowNumberswithMaxLengthcatidtypeOnly, allowNumberswithMaxLengthtypeOnly, convertFormattedToPlainNumber, currentDate, denomallowNumberswithMaxLengthtypeOnly, exportTokpientryExcel, formatNumberIndianWithDecimal, isFY2025OrLater } from "../utils/commonFunctions";

export default function KpiIndicatorEntryDistrictapprove() {

  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [distEnb, setDistEnb] = useState(false); const [distlist, setDistlist] = useState(); const [showModal, setShowModal] = useState(false); const [statusId, setStatusId] = useState(); const [deptlist, setDeptlist] = useState([]); const [periodicitylist, setPeriodicitylist] = useState(); const [yearlist, setYearlist] = useState(); const [categorylist, setCategorylist] = useState(); const [workFlow, setWorkFlow] = useState([]); const [currentstatus, setCurrentstatus] = useState(""); const [Id, setId] = useState(); const [Periodicid, setperiodicId] = useState(); const [entrydata, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [sequenceId, setSequenceId] = useState(); const [roleeid, setRoleeid] = useState(); const [addModal, setAddModal] = useState(); const [searchText, setSearchText] = useState(""); const [fieldenb, setFieldenb] = useState(false); const [multiapproveenb, setMultiapproveenb] = useState(false); const [cpoTableenb, setCpoTableenb] = useState(false); const [Cpodata, setCpodata] = useState([]);
  const [uniqueDistricts, setUniqueDistricts] = useState(); const [buttonenb, setButtonenb] = useState(false); let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid"); let deptId = localStorage.getItem("deptid"); let deptName = localStorage.getItem("deptName"); const [activePeriodicity, setActivePeriodicity] = useState("");

  const formik = useFormik({ initialValues: { userId: "", district_id: "", mandal_id: "", periodic_id: "", year: "", date: "", department_id: "", Indicators: [{ indicator_id: "", consolidatedRemarks: "", entry_value: "", numerator: "", denominator: "", multiplir: "", columns: "", maxLength: "", type: "", unit: "", targets_2025: "" }], remarks: "", entry_date: "", mandalIndicatorsData: [] } });
  const handleClose = () => { setAddModal(false); };
  const Emptyfields = () => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("category", ""); };
  const [data, setData] = useState(null);
  const periodicityMap = { monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" }, half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" } };
  React.useEffect(() => {
    if (roleid === "31" || roleid === "3" || roleid === "10" || roleid === "32" || roleid === "2") {
      setDistEnb(true);
    }
    if (roleid === "60" || roleid === "5") {
      setDistEnb(false);
    }
    formik.setFieldValue("district_id", district !== "0" ? district : ""); formik.setFieldValue("mandal_id", mandal !== "0" && mandal !== "00" ? mandal : "");
  }, []);
  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    if (roleid !== "8") {
      let paramss = { userId: username, deptId: deptId, mandal: "No", district: "Yes", state: "No", secretariat: "No" };
      KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC[0]);
          setPeriodiclistenb(true);
        } else { showAlertMessage(res.data.SDESC, "warning"); setPeriodiclistenb(false); }
      });
    }
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
        setDistlist(options);
      }
    });
    if (roleid === "8") {
      let paramss = { userId: username };
      MasterService.getDeptartments(paramss).then((res) => {
        if (res.data) {
          let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); });
          setDeptlist(options);
        }
      });
    }
    let params = { userId: username };
    KpiService.getPeriodicitylist(params).then((res20) => {
      if (res20.data) {
        let options = res20.data.SDESC.map((item, i) => { return (<option key={i} value={item.periodic_id}> {item.periodic_name} </option>); });
        setPeriodicitylist(options);
      }
    });
    store.dispatch({ type: "HIDE_SPINNER" });
  }, []);

  const restrictToPasteOnlyEightDotThreeAllowKeyPress = (formik, dist, fieldName, index) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      const regex = /^\d{1,8}(\.\d{1,3})?$/;
      if (regex.test(pasted)) {
        formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${fieldName}`, pasted);
      } else {
        showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ", "warning");
      }
    },
  });
  // useEffect(() => {

  //   formik.values?.Indicators?.forEach((item, i) => {
  //     if (item?.columns === 3) {
  //       if (!item.numerator || !item.denominator) {
  //         formik.setFieldValue(`Indicators.${i}.entry_value`, "");
  //       } else if (item.denominator !== 0) {
  //         const multiplier = item.multiplir; const devider = item.devider;
  //         const mainval = multiplier ? ((parseFloat(item.numerator) / parseFloat(item.denominator)) * parseInt(item.multiplir)).toFixed(3) : multiplier == "" && devider ? (parseFloat(item.numerator) / parseFloat(item.denominator) / parseInt(item.devider)).toFixed(3) : (parseFloat(item.numerator) / parseFloat(item.denominator)).toFixed(3);
  //         formik.setFieldValue(`Indicators.${i}.entry_value`, isFinite(mainval) ? mainval : "0");

  //       }
  //     }
  //     if (item.columns === 4) {
  //       if (!item.numerator || !item.denominator) {
  //         formik.setFieldValue(`Indicators.${i}.entry_value`, "");
  //       } else if (item.denominator !== 0) {
  //         const multiplier = item.multiplir; const devider = item.devider; const mainval = multiplier
  //           ? (((parseFloat(item.numerator) - parseFloat(item.denominator)) / parseFloat(item.denominator)) * parseInt(item.multiplir)).toFixed(3)
  //           : multiplier == "" && devider
  //           ? ((parseFloat(item.numerator) - parseFloat(item.denominator)) / parseFloat(item.denominator) / parseInt(item.devider)).toFixed(3)
  //           : (parseFloat(item.numerator) / parseFloat(item.denominator)).toFixed(3);
  //         formik.setFieldValue(`Indicators.${i}.entry_value`, isFinite(mainval) ? mainval : "0");
  //       }
  //     }
  //   });
  // }, [formik.values.Indicators]);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     ReactTooltip?.hide();
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    const updatedValues = { ...formik.values };
    let hasChanges = false;

    updatedValues.mandalIndicatorsData.forEach((indicator, i) => {
      Object.entries(indicator.entries).forEach(([districtName, entry]) => {
        const numerator = parseFloat(entry.numerator); const denominator = parseFloat(entry.denominator);
        // const unit_cat_id = parseFloat(entry.unit_cat_id); 
        const no_of_columns = parseFloat(entry.no_of_columns); const multiplier = parseFloat(entry.multiplir); const divider = parseFloat(entry.devider);
        if (no_of_columns === 3) {
          let formatted = "";

          const isValid = !isNaN(numerator) && !isNaN(denominator) && denominator !== 0;
          if (denominator == "0") {
            formatted = "0.000";
          }
          if (isValid) {

            const calculated = multiplier ? ((numerator / denominator) * multiplier) : multiplier == "" && divider ? ((numerator / denominator) / divider) : (numerator / denominator);
            formatted = calculated.toFixed(3);

          }
          if (entry.entry_value !== formatted) {
            updatedValues.mandalIndicatorsData[i].entries[districtName].entry_value = formatted;
            hasChanges = true;
          }
        }

        if (no_of_columns === 4) {
          let formatted = "";

          if (denominator == "0") {
            formatted = "0";
          }
          const isValid = !isNaN(numerator) && !isNaN(denominator) && denominator !== 0;

          if (isValid) {


            const calculated = multiplier ? (((numerator - denominator) / denominator) * multiplier) : multiplier == "" && divider ? (((numerator - denominator) / denominator) / divider) : (numerator / denominator);;
            formatted = calculated.toFixed(3);

          }
          if (entry.entry_value !== formatted) {
            updatedValues.mandalIndicatorsData[i].entries[districtName].entry_value = formatted;
            hasChanges = true;
          }
        }

      });
    });

    if (hasChanges) {
      formik.setValues(updatedValues);
    }
  }, [
    JSON.stringify(
      formik.values.mandalIndicatorsData.map(indicator =>
        Object.values(indicator.entries).map(e => [e.numerator, e.denominator, e.multiplir, e.devider])
      )
    )
  ]);

  const YearData = (e) => {
    setEntrydataEnb(false); setCpoTableenb(false); setperiodicId(e.target.value); setId(""); formik.setFieldValue("year", ""); formik.setFieldValue("date", ""); formik.setFieldValue("category", ""); setYearlist([]); setCategorylist([]);
    if (!e.target.value) { return; }
    let params = { userId: username, periodicityId: e.target.value };
    KpiService.KpiperiodicYears(params).then((res20) => {
      let years = res20.data?.SDESC?.yearsList || [];
      //let res = res20.data?.SDESC?.headList === null && e.target.value !== "8" ? years.slice(1) : years;
      let res = years

      if (res20.data) {
        let options = res.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
        setYearlist(options);
      }
    });
    setYearlist([]); setEntrydataEnb(false);
  };
  const Categorydata = (e) => {
    setCategorylist([]); formik.setFieldValue("category", ""); formik.setFieldValue("date", "");
    if (!e.target.value) {
      let missingFields = [];
      if (roleid === "8") { if (!formik.values.district_id) missingFields.push("District"); }
      if (Periodicid === "") missingFields.push("Periodicity");
      if (!e.target.value) missingFields.push("Year");
      if (missingFields.length > 0) {
        const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
        showAlertMessage(errorMessage, "warning");
      }
      setEntrydataEnb(false); setCpoTableenb(false);
      return;
    }
    const selectedYear = e.target.value;
    setId(selectedYear);

    if (["1", "2", "3", "8"].includes(Periodicid)) {
      if (roleid === "32" || roleid === "2") {
        const params = { userId: username, districtId: roleid === "60" || roleid === "5" || roleid === "8" ? formik.values.district_id : district, mandalId: "0", year: selectedYear, headId: "0", deptId: roleid === "8" ? formik.values.department_id : deptId, periodicityId: Periodicid };
        fetchEntryData(params);
      }
      if (["60", "5", "8"].includes(roleid)) {

        let paramss = { userId: username, ulbId: "0", periodicityId: formik.values.periodic_id, year: e.target.value, deptId: roleid == "8" ? formik.values.department_id : deptId, headId: "0" };
        countdata(paramss, e.target.value);
      }
    } else {
      const params = { userId: username, periodicityId: Periodicid, year: e.target.value };
      KpiService.kpiperiodicityMasterFutureDatesExtension(params).then((res) => {
        const response = res.data.SDESC.headList;
        const options = response.map((item, i) => (<option key={i} value={item.id}> {item.value} </option>));
        setCategorylist(options);
      });
    }
  };

  const getEntrydata = (e) => {
    formik.setFieldValue("Indicators", []);
    if (!e.target.value) {
      let missingFields = [];
      if (roleid === "8") { if (!formik.values.district_id) missingFields.push("District"); }
      if (formik.values.periodic_id === "") missingFields.push("Periodicity");
      if (!formik.values.year) missingFields.push("Year");
      if (!e.target.value) missingFields.push("Category");
      if (missingFields.length > 0) { const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`; showAlertMessage(errorMessage, "warning"); }
      setCpoTableenb(false); setEntrydataEnb(false);
      return;
    }
    if (["60", "5", "8"].includes(roleid)) {
      let paramss = { userId: username, ulbId: "0", periodicityId: formik.values.periodic_id, year: formik.values.year, deptId: roleid === "8" ? formik.values.department_id : deptId, headId: e.target.value };
      countdata(paramss, formik.values.year);
    } else {

      const params = { userId: username, districtId: roleid === "60" || roleid === "5" || roleid === "8" ? formik.values.district_id : district, mandalId: "0", year: Id, headId: e.target.value, deptId: roleid === "8" ? formik.values.department_id : deptId, periodicityId: Periodicid };
      fetchEntryData(params);
    }
  };

  //    const restrictToPasteEightDotThreeHandler = (formik,dist, fieldName, index) => ({
  //   onPaste: (e) => {
  //     e.preventDefault();
  //     const pasted = e.clipboardData.getData("text").trim();
  //     const regex = /^\d{1,8}(\.\d{1,3})?$/;
  //     if (regex.test(pasted)) {
  //       formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${fieldName}`, pasted);
  //     } else {
  //       showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ","warning");
  //     }
  //   },
  // });
  //     const restrictToPasteOnlyEightDotcommaThreeAllowKeyPress = (formik,dist, fieldName, index) => ({
  //   onPaste: (e) => {
  //     e.preventDefault();
  //     const pasted = e.clipboardData.getData("text").trim();
  //       const pastedClean = pasted.replace(/,/g, "");
  //       const regex = /^\d{1,8}(\.\d{1,3})?$/;
  //     if (regex.test(pastedClean)) {
  //        const formatted = formatNumberIndianWithDecimal(pastedClean);
  //      formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${fieldName}`, formatted);
  //     } else {
  //       showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ","warning");
  //     }
  //   },
  // });



  const restrictToPasteEightDotThreeHandler = (
    formik, dist, fieldName, index, isAllowedNegative, unit_cat_id

  ) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();

      // 1. Reject just a minus sign
      if (pasted === "-") {
        showAlertMessage("Please enter a valid number, not just '-'.", "warning");
        return;
      }

      // 2. Check for commas if not allowed
      if (unit_cat_id !== 1 && pasted.includes(",")) {
        showAlertMessage("Commas are not allowed in this field.", "warning");
        return;
      }

      const cleanValue = pasted.replace(/,/g, "");
      const numericValue = parseFloat(cleanValue);
      const isNumeric = !isNaN(numericValue);

      const baseRegex = /^-?\d{1,8}(\.\d{1,3})?$/;  // Accept negatives
      const rule = `${isAllowedNegative}`.trim();  // Normalize rule string
      console.log("rule", rule);
      // 3. Format validation
      if (!baseRegex.test(cleanValue)) {
        showAlertMessage(
          "Only numbers with up to 8 digits before and 3 digits after the decimal point are allowed.",
          "warning"
        );
        return;
      }

      // 4. Logical validation
      if (isNumeric) {
        switch (rule) {

          case "1": // Positive only
            console.log("rule", rule);

            if (numericValue <= 0) {
              showAlertMessage(
                "Only positive numbers are allowed.",
                "warning"
              );
              return;
            }
            break;
          case "0": // Zero and positive


            if (numericValue < 0) {
              showAlertMessage("Negative numbers are not allowed.", "warning");
              return;
            }
            break;
          case "-1":

            // All allowed — do nothing
            break;
          case "null":
            showAlertMessage(
              "Only positive numbers are allowed.",
              "warning"
            );
            break;


          default:
            showAlertMessage("Invalid configuration for number restrictions.", "warning");
            return;
        }
      }

      // 5. Set valid value
      formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${fieldName}`, pasted);
    }
  });

  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const handleCheckboxChange = (e, districtname) => { const checked = e.target.checked; setSelectedDistricts((prev) => (checked ? [...new Set([...prev, districtname])] : prev.filter((item) => item !== districtname))); };
  const normalize = (str) => str?.toLowerCase().replace(/[^a-z0-9]/gi, '');

  const countdata = (params, year) => {
    formik.setFieldValue("mandalIndicatorsData", []);
    setSelectedDistricts([]);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.HodTableData(params).then((res) => {
      if (res.data.SCODE === "01") {
        if (res.data.districtWiseIndicatorsEntryProgressReportDataStatus.length > 0) {
          const data = res.data.districtWiseIndicatorsEntryProgressReportDataStatus; setCpodata(data); setCpoTableenb(true); setEntrydataEnb(false); const uniqueDistricts = [...new Set(data.map((item) => item.district_name).filter(Boolean))]; setUniqueDistricts(uniqueDistricts);
          let enb = false;


          const districtStatusMap = {};
          data.forEach((item) => {
            const district = item.district_id;
            if (!districtStatusMap[district]) { districtStatusMap[district] = []; }
            districtStatusMap[district].push(item.status_id);
          });


          for (const district in districtStatusMap) {
            const statuses = districtStatusMap[district];

            if ((statuses.some(status_id => status_id == 3))) {
              enb = true;
              break;
            }
          }
          if (enb) {
            setButtonenb(true);
          } else {
            setButtonenb(false);
          }


          // res.data.SDESC.forEach((item) => {
          //   if (item.year !== null) setYear(item.year);
          // });
          const indicatorsMap = {};


          data.forEach((item) => {
            const unit_name = item.unit_name; const indicatorId = item.indicator_id; const districtname = item.district_name;

            console.log("item.consolidated_approver_remark", item.consolidated_approver_remark);
            if (!indicatorsMap[indicatorId]) {
              indicatorsMap[indicatorId] = { unit_name: unit_name, indicator_id: indicatorId, indicator_name: item.indicator_name || indicatorId, dividend_type: item.dividend_type, ind_type: item.ind_type, ind_phase: item.ind_phase, consolidatedRemarks: "", entries: {}, };
            }
            if (
              !indicatorsMap[indicatorId].consolidatedRemarks &&
              item.consolidated_approver_remark
            ) {
              indicatorsMap[indicatorId].consolidatedRemarks = item.consolidated_approver_remark;
            }
            indicatorsMap[indicatorId].entries[normalize(districtname)] = {
              status: item.status || "Not Yet Forwarded", no_of_columns: item.no_of_columns || "", sequence_id: item.sequence_id || "", unit_name: unit_name || "", indicator_name: item.indicator_name || "", multiplir: item.multiplir || "", devider: item.devider || "",
              status_id: item.status_id, ind_type: item.ind_type, maker_remarks: item.maker_remarks ?? "", ind_phase: item.ind_phase, district_id: item.district_id || "", mandal_code: item.mandal_code || "", unit: item.unit || "", indicator_id: indicatorId || "", max_length: item.max_length || "", numerator: item.numerator || "", denominator: item.denominator || "", entry_value: item.indicator_value || "", unit_cat_id: item.unit_cat_id || "", is_zero: item.iszero, targets_2025: item.targets_2025, targetenb: (isFY2025OrLater(year) && item.targets_2025 === null) ? true : false
            };
          });

          const mandalIndicatorsData = Object.values(indicatorsMap);
          formik.setValues((prevValues) => ({ ...prevValues, mandalIndicatorsData, }));
        } else {
          setCpodata([]); setCpoTableenb(false); showAlertMessage("No Data Found!", "warning");
        }
      } else {
        setCpoTableenb(false); setCpodata([]); showAlertMessage(res.data.SDESC, "warning");
      }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  const fetchEntryData = (params) => {
    formik.setFieldValue("Indicators", []);
    setSequenceId(null);
    if (roleid === "60" || roleid === "5") { setCpoTableenb(true); setEntrydataEnb(false); }
    if (roleid === "32" || roleid === "2") {
      setCurrentstatus("");
      setWorkFlow([]);
      KpiService.Kpientrydatadistlevel(params).then((res) => {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true); setCpoTableenb(false); setEntrydata(res.data.SDESC); setCurrentstatus(res.data.WorkFlowCurrentStatus[0]?.status || ""); setWorkFlow(res.data.getWorkFlow || []);
          res.data.SDESC.forEach((item, i) => {
            formik.setFieldValue(`Indicators[${i}].entry_value`, (() => { const raw = item.indicator_value; if (raw == null || raw === "") return ""; if (isNaN(raw)) return raw; const num = +raw; return Number.isInteger(num) ? num : Math.floor(num * 1000) / 1000; })()); formik.setFieldValue(`Indicators[${i}].indicator_id`, item.indicator_id === null ? "" : item.indicator_id); formik.setFieldValue(`Indicators[${i}].columns`, item.no_of_columns === null ? "" : item.no_of_columns); formik.setFieldValue(`Indicators[${i}].maxLength`, item.max_length === null ? "" : item.max_length); formik.setFieldValue(`Indicators[${i}].type`, item.rec_type === null ? "" : item.rec_type); formik.setFieldValue(`Indicators[${i}].unit`, item.unit === null ? "" : item.unit); formik.setFieldValue(`Indicators[${i}].numerator`, item.numerator === null ? "" : item.numerator); formik.setFieldValue(`Indicators[${i}].denominator`, item.denominator === null ? "" : item.denominator); formik.setFieldValue(`Indicators[${i}].multiplir`, item.multiplir === null ? "" : item.multiplir); formik.setFieldValue(`Indicators[${i}].devider`, item.devider === null ? "" : item.devider); formik.setFieldValue(`Indicators[${i}].targets_2025`, item.targets_2025 === null ? "" : item.targets_2025); formik.setFieldValue(`Indicators[${i}].dividend_type`, (item.dividend_type === null || item.dividend_type === undefined || item.dividend_type === "") ? "" : item.dividend_type);
            if (item.dividend_type !== null && item.dividend_type !== undefined && item.dividend_type !== "") {
              if (item.dividend_type === "Population") {
                formik.setFieldValue(`Indicators[${i}].denominator`, res.data?.population_data);
              }
              if (item.dividend_type === "GSDP") {
                formik.setFieldValue(`Indicators[${i}].denominator`, res.data?.gsdp_data);
              }
            } else {
              formik.setFieldValue(`Indicators[${i}].denominator`, item.denominator === null ? "" : item.denominator);
            }

            if (item.sequence_id !== null) {
              setSequenceId(item.sequence_id);
            }
          });
        } else {
          setEntrydata([]); setEntrydataEnb(false); showAlertMessage(res.data.SDESC, "warning");
        }
        if (Array.isArray(res.data.statusCheck) && res.data.statusCheck.length > 0) {
          setStatusId(res.data.statusCheck[0].status_id); setRoleeid(res.data.statusCheck[0].role_id);
        }
        setFieldenb(((roleid === "32" || roleid === "2") && (res.data.statusCheck[0].role_id === 60 || res.data.statusCheck[0].role_id === 5)) || res.data.statusCheck[0].role_id === 200 ? true : roleid === "8" && res.data.statusCheck[0]?.role_id === 200 ? true : false);
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    }
  };

  const filteredData =
    searchText.length > 0 && Cpodata?.length
      ? Cpodata.filter((item) => {
        return (item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }));
      })
      : Cpodata;

  const filteredDistricts = uniqueDistricts?.filter((mandal) => filteredData?.some((item) => item.district_name === mandal));
  const districtHasmaker_remarks = (districtname) =>
    Cpodata.some(
      (item) =>
        item.district_name === districtname && Number(item.ind_phase) === 4,
    );

  // columns per district: Num/Den + Achieved (+ Maker Remarks) (+ Targets)
  const getDistrictColSpan = (districtname) =>
    2 +
    // (districtHasmaker_remarks(districtname) ? 1 : 0) +
    (isFY2025OrLater(formik.values.year) ? 1 : 0);
  const validatevalue = () => {
    let val = false;
    formik.values.Indicators.map((item, index) => { if (item.entry_value) { val = true; } });
    return val;
  };
  //  const handleInputChange = (e, index, dist,field,isZero) => {
  //   const rawValue = e.target.value.trim();

  //   // if (rawValue === "") {
  //   //   showAlertMessage("Value cannot be empty", "warning", () => {
  //   //     formik.setFieldValue(`Indicators[${index}].${field}`, "");
  //   //   });
  //   //   return;
  //   // }

  //   const sanitizedValue = rawValue.replace(/,/g, "");
  //   const numericValue = parseFloat(sanitizedValue);
  //   const isDenominator = field === "denominator";

  //   // Denominator-specific rules
  //   if (isDenominator) {
  //     if (numericValue <= 0) {
  //       showAlertMessage("Denominator must be a positive number", "warning", () => {
  //         formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
  //       });
  //       return;
  //     }
  //   }
  //    else {


  //     if (numericValue === 0 && isZero !== "0") {
  //       showAlertMessage("Zero is not allowed for this indicator", "warning", () => {
  //         formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
  //       });
  //       return;
  //     }

  //     if (numericValue < 0 && isZero !== "-1") {
  //       showAlertMessage("Negative values are not allowed for this indicator", "warning", () => {
  //         formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
  //       });
  //       return;
  //     }
  //   }

  //   // Allow valid value
  //   formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, rawValue);
  // };
  const handleInputChange = ((e, index, dist, field, isZero) => {
    const rawValue = e.target.value.trim();

    // Block if just a minus sign is entered
    if (rawValue === "-") {
      showAlertMessage("Please enter a valid number, not just '-'.", "warning", () => {
        formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
      });
      return;
    }

    const sanitizedValue = rawValue.replace(/,/g, "");
    const numericValue = parseFloat(sanitizedValue);

    const isZeroRule = parseInt(isZero); // Convert once to number
    // const isDenominator = field === "numerator" || field === "denominator";

    if (!isNaN(numericValue)) {
      // Denominator-specific rules

      if (numericValue <= 0 && ![0, -1].includes(isZeroRule)) {
        console.log(isZeroRule);
        showAlertMessage("Denominator must be a positive number", "warning", () => {
          formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
        });
        return;
      }

      if (numericValue === 0 && isZeroRule === 1) {
        showAlertMessage("Only positive numbers are allowed for this indicator", "warning", () => {
          formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
        });
        return;
      }

      if (numericValue === 0 && ![0, -1].includes(isZeroRule)) {
        showAlertMessage("Zero is not allowed for this indicator", "warning", () => {
          formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
        });
        return;
      }

      if (numericValue < 0 && isZeroRule !== -1) {
        showAlertMessage("Negative values are not allowed for this indicator", "warning", () => {
          formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`, "");
        });
        return;
      }

    }

    // All validations passed
    formik.setFieldValue(`Indicators[${index}].${field}`, rawValue);
  });
  const denominatorchange = (index, dist, unit_cat_id) => {
    // if(field =="denominator"){
    // if(val<=0 && (formik.values.mandalIndicatorsData[index].entries[dist].entry_value > parseFloat(100) && [2, 9, 11].includes(unit_cat_id))){console.log("field",field,val);showAlertMessage("Denominator must be a positive number", "warning", () => {
    //   formik.setFieldValue(`mandalIndicatorsData[${index}].entries.${dist}.${field}`,"")
    // })};}
    // else{
    if (formik.values.mandalIndicatorsData[index].entries[dist].entry_value > parseFloat(100) && [2, 9, 11].includes(unit_cat_id)) { showAlertMessage("Achieved Value Exceeded 100%. Kindly check it.", "warning") }
  }

  const MultiApproveData = () => {
    setShowModal(false);
    const { num, den, finalPayload } = buildPayload();

    if (num) { showAlertMessage(`Please Enter Numerator!`, "warning"); return; }
    if (den) { showAlertMessage(`Please Enter Denominator!`, "warning"); return; }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.districtLevelIndicatorsDataEntrySave(finalPayload).then((res) => {
      showAlertMessage(res.data.SDESC, res.data.SCODE === "01" ? "success" : "warning", () => {
        setMultiapproveenb(false);
        if (res.data.SCODE === "01") {
          let params = { userId: username, ulbId: "0", periodicityId: formik.values.periodic_id, year: formik.values.year, deptId: roleid === "8" ? formik.values.department_id : deptId, headId: formik.values.category ? formik.values.category : "0", };
          countdata(params, formik.values.year);
        }
      });
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  // const submitData = () => {
  //   const val = validatevalue();
  //   if (!val) {
  //     showAlertMessage("At least one entry value must be provided.", "warning");
  //     return;
  //   }

  //   setAddModal(true);
  //   formik.setFieldValue("remarks", "");
  // };


  const checkVal = () => {
    if (!formik.values.remarks) {
      let missingFields = []; if (!formik.values.remarks) missingFields.push("Remarks"); const errorMessage = "Please Enter Remarks"; showAlertMessage(errorMessage, "warning"); return;
    }
    setMultiapproveenb(true);

    setAddModal(false); setShowModal(true);
  };
  const handleClosepop = () => { setShowModal(false); };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Escape") { e.preventDefault(); e.stopPropagation(); }
  };
  const buildPayload = () => {
    const indicaterEntryDto = [];
    const mandalMetaMap = {};
    const normalize = (str) => str?.toLowerCase().replace(/[^a-z0-9]/gi, '');
    selectedDistricts.forEach((rawDistrict) => {
      const normSelected = normalize(rawDistrict);
      const meta = Cpodata.find((item) => normalize(item.district_name) === normSelected && item.sequence_id !== null);
      if (meta) {
        mandalMetaMap[normSelected] = meta;
      }
    });
    let num = false; let den = false;

    formik.values.mandalIndicatorsData.forEach((indicator) => {
      const indicatorId = indicator.indicator_id;

      Object.entries(indicator.entries).forEach(([districtKey, entry]) => {
        const normKey = normalize(districtKey);
        if (selectedDistricts.some((d) => normalize(d) === normKey)) {
          const mandalMeta = mandalMetaMap[normKey];
          if (entry?.numerator && !entry?.denominator) { den = true }
          if (!entry?.numerator && entry?.denominator) { num = true }
          if (mandalMeta && entry.entry_value) {
            indicaterEntryDto.push({
              district_id: mandalMeta.district_id, mandal_id: "0", ulbId: "0", sequence_id: mandalMeta.sequence_id, indicator_id: indicatorId, unit: mandalMeta.unit, status_id: entry.status_id,
              indicatorType: entry.ind_type, indicator_value: indicator.unit_cat_id === 13 ? entry.entry_value : convertFormattedToPlainNumber(entry.entry_value), numerator: entry.numerator || "0", denominator: entry.denominator || "0", makerRemarks: entry.maker_remarks,
              consolidatedApproverRemark: Number(indicator.ind_phase) === 4 ? (indicator.consolidatedRemarks ?? "") : ""
            });
          }
        }
      });
    });

    const finalPayload = {
      type: multiapproveenb ? "multiApprove" : "multiUpdate",
      userId: username,
      dept_id: roleid === "8" ? formik.values.department_id : deptId,
      // status_id: multiapproveenb ? 4 : 3,
      // newIndicatorsStatus: multiapproveenb ? 4 : 3,
      role_id: multiapproveenb ? 200 : 60,
      periodicity_id: formik.values.periodic_id,
      ...(multiapproveenb ? { remarks: formik.values.remarks } : {}),
      year: formik.values.year,
      head_id: formik.values.category || "0",
      indicaterEntryDto,
    };

    return { num, den, finalPayload };
  };

  const savemultientry = () => {
    if (selectedDistricts.length === 0) {
      showAlertMessage("Please Select Any One District to Update... ", "warning");
      return;
    }
    const { num, den, finalPayload } = buildPayload();

    if (num) { showAlertMessage(`Please Enter Numerator!`, "warning"); return; }
    if (den) { showAlertMessage(`Please Enter Denominator!`, "warning"); return; }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.districtLevelIndicatorsDataEntrySave(finalPayload).then((res) => {
      showAlertMessage(res.data.SDESC, res.data.SCODE === "01" ? "success" : "warning", () => {
        setSelectedDistricts([]);
        setShowModal(false);
        if (res.data.SCODE === "01") {
          let params = { userId: username, ulbId: "0", periodicityId: formik.values.periodic_id, year: formik.values.year, deptId: roleid === "8" ? formik.values.department_id : deptId, headId: formik.values.category ? formik.values.category : "0", };
          countdata(params, formik.values.year);
        }
      });
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });



  };

  // const ForwardDataHod = () => {
  //   if (!formik.values.remarks) {
  //     let missingFields = [];
  //     if (!formik.values.remarks) missingFields.push("Remarks");
  //     const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
  //     showAlertMessage(errorMessage, "warning");
  //     return;
  //   }

  //   let params = { type: "forward", userId: username, dept_id: deptId, district_id: district, mandal_id: "0", sequence_id: sequenceId, status_id: 3, role_id: 60, periodicity_id: Periodicid, remarks: formik.values.remarks, year: formik.values.year || 0, head_id: formik.values.category || 0, indicaterEntryDto: [], };
  //   params.indicaterEntryDto = formik.values.Indicators.map((item, index) =>
  //     item.entry_value
  //       ? { indicator_id: item.indicator_id, unit: item.unit, indicator_value: item.entry_value, numerator: item.numerator || 0, denominator: item.denominator || 0, } : null
  //   ).filter(Boolean); 
  //   KpiService.SaveKpiMandalentrydistlevel(params).then((res) => {
  //     setShowModal(false);
  //     setAddModal(false);
  //     showAlertMessage(res.data.SDESC, res.data.SCODE === "01" ? "success" : "warning", () => {
  //       formik.setFieldValue("remarks", "");
  //       const fetchParams = { userId: username, districtId: roleid === "60" || roleid === "5" ? formik.values.district_id : district, mandalId: "0", year: Id, headId: formik.values.category || 0, deptId: roleid === "8" ? formik.values.department_id:deptId, periodicityId: Periodicid };

  //       KpiService.Kpientrydatadistlevel(fetchParams).then((res) => {
  //           if (res.data.statusCheck.length > 0) { setStatusId(res.data.statusCheck[0].status_id); setRoleeid(res.data.statusCheck[0].role_id); }
  //           setFieldenb(
  //             ((roleid === "32" || roleid === "2") && (res.data.statusCheck[0].role_id === 60 || res.data.statusCheck[0].role_id === 5)) || res.data.statusCheck[0].role_id === 200 ? true : (roleid === "60" || roleid === "5") && (res.data.statusCheck[0].role_id === 32 || res.data.statusCheck[0].role_id === 3) ? true : roleid === "8" && res.data.statusCheck[0]?.role_id === 200 ? true : false
  //           );
  //           store.dispatch({ type: "HIDE_SPINNER" });
  //           if (res.data.WorkFlowCurrentStatus.length > 0) {
  //             setCurrentstatus(res.data.WorkFlowCurrentStatus[0].status);
  //             setWorkFlow(res.data.getWorkFlow);
  //           }
  //           if (res.data.SCODE === "01") {
  //             setEntrydata(res.data.SDESC);
  //             res.data.SDESC.forEach((item, i) => {
  //             formik.setFieldValue( `Indicators[${i}].entry_value`, (() => { const raw = item.indicator_value; if (raw == null || raw === "") return ""; if (isNaN(raw)) return raw; const num = +raw; return Number.isInteger(num) ? num : Math.floor(num * 1000) / 1000; })() );
  //               if (item.sequence_id !== null) {
  //                 setSequenceId(item.sequence_id);
  //               }
  //             });
  //           }
  //         }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  //     });
  //   });
  // };
  const [showRemarksConfirm, setShowRemarksConfirm] = useState(false);
  const [missingRemarkNames, setMissingRemarkNames] = useState([]);
  // number of districts that are not fully approved (any record with status_id !== 4)
  // const getPendingDistrictCount = () => {
  //   const map = {};
  //   Cpodata.forEach((item) => {
  //     if (!item.district_name) return;
  //     if (!map[item.district_name]) map[item.district_name] = [];
  //     map[item.district_name].push(item.status_id);
  //   });
  //   return Object.values(map).filter((statuses) =>
  //     statuses.some((s) => Number(s) === 3),
  //   ).length;
  // };

  // pending  = districts with at least one status_id 3 (forwarded, waiting for approval)
  // others   = districts that are neither fully approved (all 4) nor pending (e.g. 0, null, 2)
  const getDistrictApprovalSummary = () => {
    const map = {};
    Cpodata.forEach((item) => {
      if (!item.district_name) return;
      if (!map[item.district_name]) map[item.district_name] = [];
      map[item.district_name].push(item.status_id);
    });

    const allDistricts = Object.keys(map);
    const total = allDistricts.length;

    // districts where every record is status 4
    const approvedDistricts = allDistricts.filter((d) =>
      map[d].every((s) => Number(s) === 4)
    );

    // selected districts that are not already approved
    const selectedCount = selectedDistricts.filter(
      (d) => map[d] && !approvedDistricts.includes(d)
    ).length;

    // districts not approved (status !== 4) and NOT selected now
    const remainingNotSelected = allDistricts.filter(
      (d) => !approvedDistricts.includes(d) && !selectedDistricts.includes(d)
    ).length;

    // selected + already approved === total  → this approval completes everything
    const isFinalApproval = selectedCount + approvedDistricts.length === total;

    return { total, selectedCount, approvedCount: approvedDistricts.length, remainingNotSelected, isFinalApproval };
  };
  // ind_phase 4 indicators whose consolidated remarks are empty
  const getIndicatorsMissingRemarks = () =>
    formik.values.mandalIndicatorsData
      .map((ind, idx) => ({ ind, slNo: idx + 1 }))
      .filter(
        ({ ind }) =>
          Number(ind.ind_phase) === 4 &&
          !(ind.consolidatedRemarks ?? "").toString().trim(),
      )
      .map(({ ind, slNo }) => `${slNo}. ${ind.indicator_name}`);

  const ForwardHodmultipop = () => {
    formik.setFieldValue("remarks", "");
    if (selectedDistricts.length === 0) {
      showAlertMessage("Please Select Any One District to approve... ", "warning");
      return;
    }

    const incompleteDistricts = [];

    selectedDistricts.forEach((districtname) => {
      let hasMissingEntries = false;

      formik.values.mandalIndicatorsData.forEach((indicator) => {
        const entry = indicator.entries[normalize(districtname)];

        if (entry) {
          const hasTarget =
            entry.targets_2025 !== null && entry.targets_2025 !== "";
          const noEntry =
            entry.entry_value === null || entry.entry_value === "";

          if (hasTarget && noEntry) {
            hasMissingEntries = true;
          }
        }
      });

      if (hasMissingEntries) {
        incompleteDistricts.push(districtname);
      }
    });

    if (incompleteDistricts.length > 0) {
      showAlertMessage(
        `Please enter values for all indicators which have targets assigned in the following
       "District(s)" ${incompleteDistricts.join(", ")}.`,
        "warning"
      );
      return;
    }

    // ---- consolidated remarks validation ----
    const { isFinalApproval, remainingNotSelected } = getDistrictApprovalSummary();
    const missing = getIndicatorsMissingRemarks();

    if (missing.length > 0) {
      // Case 1: this approval completes all districts -> remarks mandatory, block
      if (isFinalApproval) {
        showAlertMessage(
          `Consolidated Remarks must be entered for the following indicator(s): ${missing.join("; ")}`,
          "warning"
        );
        return;
      }

      // Case 2: some district (status !== 4) is not selected -> warn, let user decide
      if (remainingNotSelected > 0) {
        setMissingRemarkNames(missing);
        setShowRemarksConfirm(true); // Yes -> setAddModal(true), No -> nothing
        return;
      }
    }

    setAddModal(true);
    // const { pending, others } = getDistrictApprovalSummary();
    // const missing = getIndicatorsMissingRemarks();

    // // applies only when every district that is NOT at status 3 is fully approved (4)
    // const rulesApply = others === 0 && pending >= 1 && pending <= 5;

    // if (rulesApply && missing.length > 0) {
    //   // exactly 1 district at status 3: remarks are mandatory, modal stays blocked
    //   if (pending === 1) {
    //     showAlertMessage(
    //       `Consolidated Remarks must be entered for the following indicator(s): ${missing.join("; ")}`,
    //       "warning"
    //     );
    //     return; // setAddModal(true) is NOT reached
    //   }

    //   // 2 to 4 districts at status 3: ask for confirmation
    //   setMissingRemarkNames(missing);
    //   setShowRemarksConfirm(true); // Yes -> setAddModal(true), No -> nothing
    //   return;
    // }



    // // let enable = validatefieldvalues(); if (enable) { return; } 
    // setAddModal(true);
  };



  const BackFunct = () => {
    setSearchText("");
    let paramss = { userId: username, ulbId: "0", periodicityId: formik.values.periodic_id, year: formik.values.year, deptId: roleid === "8" ? formik.values.department_id : deptId, headId: formik.values.category ? formik.values.category : "0" };
    countdata(paramss);
    setCpoTableenb(true);
    setEntrydataEnb(false);
  };
  useEffect(() => {
    if (data) {
      const firstKey = Object.entries(periodicityMap).find(([key]) => data?.[key] > 0);
      if (firstKey) {
        const { value } = firstKey[1];
        setActivePeriodicity(value);
        const syntheticEvent = { target: { name: "periodic_id", value } };
        YearData(syntheticEvent);
        formik.handleChange(syntheticEvent);
      }
    }
  }, [data]);
  const [periodiclistenb, setPeriodiclistenb] = useState(false);

  const perioicitylist = (e) => {
    formik.setFieldValue("mandal_id", ""); formik.setFieldValue("district_id", ""); setPeriodiclistenb(false); setEntrydataEnb(false); setCpoTableenb(false);
    let paramss = { userId: username, deptId: e.target.value, mandal: "No", district: "Yes", state: "No", secretariat: "No" };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC[0]); setPeriodiclistenb(true);
        } else { showAlertMessage(res.data.SDESC, "warning"); setPeriodiclistenb(false); setEntrydataEnb(false); }
      }
    });
  };
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "95%" }} className="map-header "> <div className="sa-title"> <h2> Indicator <span> Entry -District Level</span> </h2> </div> </Container>
      <Container fluid style={{ width: "95%" }} className="mt-3 outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                {roleid !== "8" && (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select"> <label className="mb-1 fw-bold">Secretariat Name</label> <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("SectariatcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}></Field> </Col>
                )}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold">HOD Name</label>
                  {roleid === "8" ? (
                    <Field component="select" name="department_id" className="mb-3 form-control" onChange={(e) => { Emptyfields(); formik.handleChange(e); perioicitylist(e); }} style={{ fontWeight: "bold" }} disabled={deptId === "179" || roleid === "8" ? false : true} > <option value="">--Select--</option> {deptlist} </Field>
                  ) : (
                    <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("deptcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}></Field>
                  )}
                </Col>
                {roleid === "32" || roleid === "2" ? (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                    <label className="mb-1 fw-bold">District</label> <Field className="mb-3 form-control" component="select" onChange={(e) => { Emptyfields(); formik.handleChange(e); }} name="district_id" controlId="formBasicEmail" disabled={distEnb} style={{ fontWeight: "bold" }} > <option value="">--Select--</option> {distlist} </Field>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>
            {periodiclistenb && (
              <>
                <div className="tabs-top">
                  <Nav variant="pills" className="tabs-row d-flex flex-wrap justify-content-start gap-1 mb-2 mt-4">
                    {Object.entries(periodicityMap)
                      .filter(([key]) => data?.[key] > 0)
                      .map(([key, { label, value }]) => (
                        <div key={key} className="flex-grow-1 flex-shrink-0" style={{ maxWidth: "120px" }}>
                          <Nav.Item className="tab-boxes-small">
                            <Nav.Link eventKey={value} onClick={() => { const syntheticEvent = { target: { name: "periodic_id", value }, }; setActivePeriodicity(value); YearData(syntheticEvent); formik.handleChange(syntheticEvent); formik.setFieldValue("mandalIndicatorsData", []); }} active={activePeriodicity === value} className="text-center" > <p className="text-truncate text-center m-0">{label}</p> </Nav.Link>
                          </Nav.Item>
                        </div>
                      ))}
                  </Nav>
                </div>
                <Row>
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select " style={{ marginLeft: "15px" }}>
                    <label className="mb-1 fw-bold">Year</label>
                    <Field className="mb-3 form-control" component="select" name="year" controlId="formBasicEmail" onChange={(e) => { Categorydata(e); formik.handleChange(e); }} style={{ fontWeight: "bold" }} >
                      <option value="">--Select--</option> {yearlist}
                    </Field>
                  </Col>

                  {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7") && (
                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                      <label className="mb-1 fw-bold">Category</label>
                      <Field className="mb-3 form-control" component="select" name="category" controlId="formBasicEmail" style={{ fontWeight: "bold" }} onChange={(e) => { getEntrydata(e); formik.handleChange(e); }} > <option value="">--Select--</option> {categorylist} </Field>
                    </Col>
                  )}

                  {Periodicid === "4" && (Id === "2025" || Id === "2024" || Id === "2023") && (
                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select"> <label className="mb-1 fw-bold">Date</label> <Field className="mb-3 form-control" type="date" name="date" onChange={(e) => { getEntrydata(e); formik.handleChange(e); }} max={currentDate} controlId="formBasicEmail" style={{ fontWeight: "bold" }} /> </Col>
                  )}
                </Row>
              </>
            )}

            <Nav variant="pills" className="flex-column">
              <Row className="tabs-row">
                <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0"></Col> <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0"></Col> <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"></Col> <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"></Col>
                {(roleid === "60" || roleid === "5") && entrydataEnb && (
                  <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"> <Button variant="warning" size="sm" className="btn mx-4 mt-4 warn-btn" onClick={() => { BackFunct(); }} > <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </Button> </Col>
                )}
              </Row>
            </Nav>

            {cpoTableenb && (
              <>
                <Row className="mt-3">
                  <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
                    <Row>
                      <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <button type="button" style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearchText(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </button> </Col>

                      <Col className=" mb-2 "> <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportTokpientryExcel("my-table1", formik.values, "DistrictLevelKPIIndicatorReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> </Col>
                    </Row>
                    <div className="kp-indicatortable ">
                      <div id="table-scroll" className="table-scroll table-wrap mt-2 mb-5">
                        <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table1">
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                            <tr className="text-center">
                              <th rowSpan={2} className="sticky-col sticky-sno"> Sl.No. </th> <th rowSpan={2} className="sticky-col sticky-INDICATOR indicator-cell"> Indicator </th> <th rowSpan={2} className="sticky-col sticky-UNIT unit-column"> Unit </th>

                              {/* {filteredDistricts.map((districtname, idx) => {

  const districtRecords = Cpodata.filter(item => item.district_name === districtname);

  const hasApproved = districtRecords.some(item => item.status_id == 4);
  const allValidStatuses = districtRecords.some(item => 
    item.status_id == 3 
  );

  const showCheckbox = !hasApproved && allValidStatuses; */}
                              {formik.values.mandalIndicatorsData?.some(
                                (item) => Number(item.ind_phase) === 4,
                              ) && (
                                  <th
                                    rowSpan={2}
                                    className="sticky-col sticky-Remarks"
                                  >
                                    Consolidated Remarks
                                  </th>
                                )}
                              {filteredDistricts.map((districtname, idx) => {
                                const districtRecords = Cpodata.filter(item => item.district_name === districtname);

                                const allApproved = districtRecords.length > 0 && districtRecords.every(item => item.status_id == 4);
                                const hasAtLeastOneValid = districtRecords.some(item => item.status_id == 3);

                                const showCheckbox = !allApproved && hasAtLeastOneValid;

                                return (
                                  <th colSpan={getDistrictColSpan(districtname)} key={idx} style={{ textAlign: "center" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}> <span>{districtname}</span> {showCheckbox && (<label className="custom-checkbox" style={{ marginBottom: 0 }}> <input type="checkbox" checked={selectedDistricts.includes(districtname)} onChange={(e) => handleCheckboxChange(e, districtname)} /> <span className="checkmark"></span> </label>)} </div>
                                  </th>
                                );
                              })}

                            </tr>
                            <tr className="text-center">
                              {filteredDistricts?.map((districtname, idx) => (
                                <React.Fragment key={idx}> <th>Numerator/Denominator</th> <th> Achieved Value</th>
                                  {/* {districtHasmaker_remarks(districtname) && (<th>Maker<br /> Remarks</th>)} */}
                                  {isFY2025OrLater(formik.values.year) && <th> Targets<br />({formik.values.year})</th>}</React.Fragment>
                              ))}
                            </tr>
                          </thead>



                          <tbody>
                            {(() => {
                              const districtsWithAllNotStarted = {}; const districtsWithFirstRowRendered = {}; const districtsWithStartedIndicators = {}; const districtsWithApproved = {};
                              const hasOldStatusByMandal = {}; const hasForwardByDistrict = {};
                              filteredDistricts.forEach((districtname) => {
                                const dist = normalize(districtname);

                                districtsWithApproved[districtname] = formik.values.mandalIndicatorsData.some((indicator) => {
                                  const entry = indicator.entries?.[dist];
                                  return entry?.status_id === 4;
                                });

                                districtsWithStartedIndicators[dist] = formik.values.mandalIndicatorsData.some((indicator) => {
                                  const entry = indicator.entries?.[dist];
                                  const hasUserInput = entry?.numerator || entry?.denominator || entry?.entry_value;
                                  return entry && ((![0, null].includes(entry.status_id)) || hasUserInput);
                                });

                                districtsWithAllNotStarted[dist] = formik.values.mandalIndicatorsData.every((indicator) => {
                                  const entry = indicator.entries?.[dist];
                                  const noUserInput = !entry?.numerator && !entry?.denominator && !entry?.entry_value;
                                  return (!entry || [0, null].includes(entry.status_id)) && noUserInput;
                                });

                                hasOldStatusByMandal[districtname] =
                                  formik.values.mandalIndicatorsData.some((indicator) => {
                                    const entry = indicator.entries?.[dist];
                                    return entry && entry.status_id === 4;
                                  });
                                hasForwardByDistrict[districtname] =
                                  formik.values.mandalIndicatorsData.some((indicator) => {
                                    const entry = indicator.entries?.[dist];
                                    return entry && entry.status_id === 3;
                                  });
                              });

                              return formik.values.mandalIndicatorsData.map((indicator, i) => (
                                <tr key={indicator.indicator_id}>
                                  <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}>{i + 1}</td>
                                  <td className="sticky-col sticky-INDICATOR indicator-column">
                                    {indicator.ind_type === "N" &&
                                      <img src="../images/new3.gif" width="20px" alt="new" style={{ marginRight: "5px" }} />}
                                    {indicator.indicator_name}
                                  </td>

                                  <td className="sticky-col sticky-UNIT unit-column">{indicator.unit_name}</td>
                                  {formik.values.mandalIndicatorsData?.some(
                                    (item) => Number(item.ind_phase) === 4,
                                  ) && (
                                      <td className="sticky-col sticky-Remarks">
                                        {Number(indicator.ind_phase) === 4 && (
                                          <Field
                                            as="textarea"
                                            name={`mandalIndicatorsData[${i}].consolidatedRemarks`}
                                            value={
                                              formik.values
                                                .mandalIndicatorsData[i]
                                                ?.consolidatedRemarks ?? ""
                                            }
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                `mandalIndicatorsData[${i}].consolidatedRemarks`,
                                                e.target.value,
                                              );
                                            }}
                                            className="form-control"
                                            rows={2}
                                            placeholder="Enter Remarks"
                                            disabled={!buttonenb}
                                          />
                                        )}
                                      </td>
                                    )}
                                  {filteredDistricts.map((districtname) => {
                                    const dist = normalize(districtname);
                                    const entry = indicator.entries?.[dist];

                                    // const isDisabled = districtsWithApproved[districtname];
                                    const oldStatusDisabled =
                                      entry?.ind_type === "O" && hasOldStatusByMandal[districtname];
                                    if (districtsWithAllNotStarted[dist]) {
                                      if (districtsWithFirstRowRendered[dist]) {
                                        return null;
                                      } else {
                                        districtsWithFirstRowRendered[dist] = true;
                                        return (
                                          <td key={dist} colSpan={getDistrictColSpan(districtname)} rowSpan={formik.values.mandalIndicatorsData.length} style={{ textAlign: "center", verticalAlign: "middle" }}> Not Yet Forwarded </td>
                                        );
                                      }
                                    } else {
                                      const hasUserInput = entry?.numerator || entry?.denominator || entry?.entry_value;
                                      const shouldShowFields = districtsWithStartedIndicators[dist] || (entry && entry.status_id == 4) || hasUserInput;

                                      return (
                                        <React.Fragment key={dist}>
                                          {shouldShowFields ? (
                                            <>
                                              {entry?.no_of_columns === 3 ? (
                                                <td className="text-right text-end">
                                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    <Field
                                                      autoComplete="off"
                                                      name={`mandalIndicatorsData[${i}].entries.${dist}.numerator`}
                                                      disabled={[4].includes(entry?.status_id) || (!hasForwardByDistrict[districtname] && [null, "", 0].includes(entry?.status_id)) || oldStatusDisabled || entry?.targetenb}
                                                      className="form-control"
                                                      type="text"
                                                      onInput={(e) => allowNumberswithMaxLengthtypeOnly(e, entry?.max_length, "numeric", 3, entry?.is_zero)}
                                                      onBlur={(e) => {
                                                        handleInputChange(e, i, dist, "numerator", entry?.is_zero);
                                                        denominatorchange(i, dist, entry.unit_cat_id); formik.handleChange(e);
                                                      }}
                                                      style={{ textAlign: "right" }}
                                                      {...restrictToPasteEightDotThreeHandler(formik, dist, "numerator", i, entry?.is_zero, entry?.unit_cat_id)}
                                                    />
                                                    <span style={{ fontSize: "15px" }}>/</span>
                                                    <Field
                                                      autoComplete="off"
                                                      name={`mandalIndicatorsData[${i}].entries.${dist}.denominator`}
                                                      className="form-control"
                                                      disabled={[4].includes(entry?.status_id) || (!hasForwardByDistrict[districtname] && [null, "", 0].includes(entry?.status_id)) || oldStatusDisabled || (formik.values.mandalIndicatorsData[i].dividend_type !== null && formik.values.mandalIndicatorsData[i].dividend_type !== undefined && formik.values.mandalIndicatorsData[i].dividend_type !== "") || entry?.targetenb}
                                                      onBlur={(e) => {
                                                        handleInputChange(e, i, dist, "denominator", entry?.is_zero);
                                                        denominatorchange(i, dist, entry.unit_cat_id); formik.handleChange(e);
                                                      }}
                                                      type="text"
                                                      onInput={(e) => { denomallowNumberswithMaxLengthtypeOnly(e, entry?.max_length, "numeric", 3,) }}

                                                      //onKeyPress={(e) => allowNumberswithMaxLengthtypeOnly(e, entry?.max_length, "numeric", 3,entry?.is_zero)}
                                                      style={{ textAlign: "right" }}
                                                      {...restrictToPasteOnlyEightDotThreeAllowKeyPress(formik, dist, "denominator", i)}
                                                    />
                                                  </div>
                                                </td>
                                              ) : (
                                                <td></td>
                                              )}

                                              <td className="text-right text-end"> <div className="d-flex align-items-center">
                                                {entry.unit_cat_id !== 13 ? (<>
                                                  <Field
                                                    autoComplete="off"
                                                    className="form-control"
                                                    name={`mandalIndicatorsData[${i}].entries.${dist}.entry_value`}
                                                    value={
                                                      entry.unit_cat_id === 1
                                                        ? formatNumberIndianWithDecimal(formik.values.mandalIndicatorsData[i].entries[dist].entry_value)
                                                        : formik.values.mandalIndicatorsData[i].entries[dist].entry_value
                                                    }
                                                    disabled={[4].includes(entry?.status_id) || (!hasForwardByDistrict[districtname] && [null, "", 0].includes(entry?.status_id)) || oldStatusDisabled || entry?.no_of_columns === 3 || entry?.targetenb}
                                                    onBlur={(e) => { handleInputChange(e, i, dist, "entry_value", entry?.is_zero); formik.handleChange(e); }}
                                                    onInput={(e) => {
                                                      if (entry.unit_cat_id === 1) {
                                                        allowNumberswithMaxLengthcatidtypeOnly(e, entry?.max_length, "numeric", 3, entry?.is_zero);
                                                      } else {
                                                        allowNumberswithMaxLengthtypeOnly(e, entry?.max_length, "numeric", 3, entry?.is_zero);
                                                      }
                                                    }}
                                                    {...restrictToPasteEightDotThreeHandler(formik, dist, "entry_value", i, entry?.is_zero, entry?.unit_cat_id)}
                                                    type="text"
                                                    style={{ textAlign: "right" }}
                                                  />
                                                  {/* {districtHasmaker_remarks(districtname) && Number(entry?.ind_phase) === 4 && entry?.maker_remarks && (
                                                    <OverlayTrigger
                                                      placement="top"
                                                      trigger={["hover", "focus"]}
                                                      container={typeof document !== "undefined" ? document.body : undefined}
                                                      overlay={
                                                        <Tooltip id={`tooltip-maker-${i}-${dist}`} className="custom-tooltipp">
                                                          <strong style={{ fontSize: "18px" }}>Maker Remarks: </strong>
                                                          <br />
                                                          {entry.maker_remarks}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <span
                                                        tabIndex={0}
                                                        style={{ cursor: "pointer", display: "inline-block" }}
                                                      >
                                                        <AiOutlineEye style={{ fontSize: "22px", color: "#0d6efd" }} />
                                                      </span>
                                                    </OverlayTrigger>
                                                  )}</> */}
                                                </>
                                                ) : (
                                                  <Field component="select" name={`Indicators[${i}].entry_value`} className="form-control mb-3" style={{ fontWeight: "bold" }} disabled={[4].includes(entry?.status_id) || (!hasForwardByDistrict[districtname] && [null, "", 0].includes(entry?.status_id)) || oldStatusDisabled || entry?.no_of_columns === 3} >
                                                    <option value="">--Select--</option> <option value="100">TOP ACHIEVERS</option> <option value="75">ACHIEVERS</option> <option value="50">FAST MOVERS</option> <option value="25">ASPIRERS</option>
                                                  </Field>
                                                )}
                                              </div>
                                              </td>

                                              {/* {districtHasmaker_remarks(districtname) && (
                                                <td>
                                                  {Number(entry?.ind_phase) === 4 && (
                                                    <Field
                                                      as="textarea"
                                                      name={`mandalIndicatorsData[${i}].entries.${dist}.maker_remarks`}
                                                      className="form-control"
                                                      rows={2}
                                                      // disabled={
                                                      //   [4].includes(entry?.status_id) ||
                                                      //   (!hasForwardByDistrict[districtname] &&
                                                      //     [null, "", 0].includes(entry?.status_id)) ||
                                                      //   oldStatusDisabled ||
                                                      //   entry?.no_of_columns === 3 ||
                                                      //   entry?.targetenb
                                                      //}
                                                      disabled
                                                    />
                                                  )}
                                                  
                                                </td>
                                              )} */}
                                              {isFY2025OrLater(formik.values.year) && <td style={{ textAlign: "right" }} > {entry?.targets_2025}
                                                {districtHasmaker_remarks(districtname) && Number(entry?.ind_phase) === 4 && entry?.maker_remarks && (
                                                  <OverlayTrigger
                                                    placement="top"
                                                    trigger={["hover", "focus"]}
                                                    container={typeof document !== "undefined" ? document.body : undefined}
                                                    overlay={
                                                      <Tooltip id={`tooltip-maker-${i}-${dist}`} className="custom-tooltipp">
                                                        <strong style={{ fontSize: "18px" }}>Maker Remarks: </strong>
                                                        <br />
                                                        {entry.maker_remarks}
                                                      </Tooltip>
                                                    }
                                                  >

                                                    <span
                                                      tabIndex={0}
                                                      style={{ cursor: "pointer", display: "inline-block" }}
                                                    >
                                                      <img src="images/remarks.png" alt="info"
                                                        style={{ width: "20px", height: "20px", marginLeft: "10px" }} className="img-fluid" />
                                                      {/* <AiOutlineEye style={{ fontSize: "22px", color: "#0d6efd" }} /> */}
                                                    </span>
                                                  </OverlayTrigger>
                                                )}
                                              </td>}
                                            </>
                                          ) : (
                                            <td colSpan={isFY2025OrLater(formik.values.year) ? 3 : 2} style={{ textAlign: "center" }}> Not Yet Forwarded </td>
                                          )}
                                        </React.Fragment>
                                      );
                                    }
                                  })}
                                </tr>
                              ));
                            })()}
                          </tbody>

                        </table>   </div> </div>
                    {buttonenb && (
                      <div className="bottom-buttons d-flex justify-content-center mt-2 mb-5"> <Button variant="" size="sm" className="save-btn  mx-4 mt-2" onClick={() => savemultientry()}> Update <FaRegSave className="ms-1 s-icon" /> </Button> <Button variant="" size="sm" className="next-btn  mx-4 mt-2" onClick={() => ForwardHodmultipop()}> Approve <FaRegSave className="ms-1 s-icon" /> </Button> </div>
                    )}
                  </Col>
                </Row>
              </>
            )}
            <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={addModal}>
              <Modal.Header>
                {["8", "60", "5"].includes(roleid) ? (
                  <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "black", fontFamily: "'Times New Roman', Times, serif" }}> Confirm & Approve </Modal.Title>
                ) : (
                  <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "black", fontFamily: "'Times New Roman', Times, serif" }}> Forward To </Modal.Title>
                )}
                <span role="button" tabIndex={0} onClick={handleClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClose(); } }} style={{ cursor: "pointer", color: "white" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>
              </Modal.Header>
              <Modal.Body className="p-5">
                <Modal.Dialog className="internal">
                  {!["8", "60", "5"].includes(roleid) && (


                    <Modal.Body>
                      <p className="d-flex">
                        <FaUserCheck className="usericon" />

                        <Field type="text" style={{ margin: "0 auto", color: "black", fontSize: "15px", fontWeight: "bold", fontFamily: "Arial, sans-serif" }} value={["32", "2"].includes(roleid) && `HOD (${deptName})`} className="form-control" disabled={true}></Field>
                      </p>
                    </Modal.Body>

                  )}
                  <Modal.Footer> Remarks <sup className="mandatort">*</sup> <Field as="textarea" name="remarks" rows={2} cols={40} style={{ resize: "none" }} maxLength={200} /> </Modal.Footer>
                </Modal.Dialog>
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="conform" onClick={checkVal}> Confirm <FaRegFile /> </button>
              </Modal.Footer>
            </Modal>
            <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={showModal} onHide={null} backdrop="static" keyboard={false}>
              <Modal.Header>
                <Modal.Title></Modal.Title>
                <span role="button" tabIndex={0} onClick={handleClosepop} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClosepop(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} style={{ fontSize: "30px", cursor: "pointer" }} className="me-1" > &#215; </span>
              </Modal.Header>
              <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center" onKeyDown={handleKeyDown}>
                <div className="text-center">
                  <img src="images/question.gif" style={{ width: "70px", marginBottom: "10px" }} alt="Warning Icon" /> <p className="fw-bold" style={{ fontSize: "17px" }}> Are you sure you want to {roleid === "32" || roleid === "2" ? "Forward" : "Approve"}? Once Submitted no further changes will be allowed. </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {["8", "60", "5"].includes(roleid) && (
                  <button type="button" className="conform" onClick={() => { MultiApproveData(); }} > Yes </button>)} <button type="button" className="cancel" onClick={handleClosepop}> No </button>
              </Modal.Footer>
            </Modal>
            <Modal fade={false} className="newmodal" centered show={showRemarksConfirm} backdrop="static" keyboard={false}>
              <Modal.Header>
                <Modal.Title></Modal.Title>
                <button
                  type="button"
                  aria-label="Close"
                  onClick={() => setShowRemarksConfirm(false)}
                  style={{
                    fontSize: "30px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    lineHeight: 1,
                  }}
                  className="me-1"
                >
                  &#215;
                </button>
              </Modal.Header>
              <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center" onKeyDown={handleKeyDown}>
                <img src="images/question.gif" style={{ width: "70px", marginBottom: "10px" }} alt="Warning Icon" />
                <p className="fw-bold" style={{ fontSize: "17px", textAlign: "center" }}>
                  Consolidated Remarks should be entered for Economic indicators.<br />
                  Do you still want to continue?
                </p>
                {/* <div style={{ textAlign: "left", maxHeight: "150px", overflowY: "auto" }}>
                  {missingRemarkNames.map((name, i) => (<div key={i}>{name}</div>))}
                </div> */}

              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="conform" onClick={() => { setShowRemarksConfirm(false); setAddModal(true); }}> Yes </button>
                <button type="button" className="cancel" onClick={() => setShowRemarksConfirm(false)}> No </button>
              </Modal.Footer>
            </Modal>
          </Form>
        </FormikProvider>
      </Container >
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
